import { Map } from 'immutable';
import type { ValidationErrors } from '@frontend/utils';

export type ProcessKey = { checkKey: string; targetKey: string };
export function transformValidationErrors(
    originalErrors: ValidationErrors,
    keysToProcess: ProcessKey[]
): ValidationErrors {
    return Map<string, string | undefined>(keysToProcess.map((key) => processError(originalErrors, key)));
}

/**
 * Processes an individual error key.
 *
 * @param errors The current ValidationErrors object.
 * @param checkKey The key to check in the ValidationErrors.
 * @param targetKey The key to set or remove in the ValidationErrors.
 * @returns A new ValidationErrors object with the processed key.
 */
function processError(errors: ValidationErrors, key: ProcessKey): [string, string | undefined] | undefined {
    // Check if the errors object contains the checkKey.
    if (errors.has(key.checkKey)) {
        // If so, set the targetKey with a specific value.
        return [key.targetKey, 'string_base'];
    } else {
        return undefined;
    }
}
